<template>
    <div class="wrap">
        <listHeader :title="postData.sdid > 0 ? '工资明细' : '工资明细'"></listHeader>

        <div class="wrap-list-content">

            <div class="wrap-form-view">

                <table class="table">
                    <tr>
                        <td class="title">工资月</td>
                        <td class="content">{{ data.month_str }}</td>
                    </tr>
                    <tr>
                        <td class="title">姓名</td>
                        <td class="content">{{ data.name }}</td>
                    </tr>
                    <tr>
                        <td class="title">工作单位</td>
                        <td class="content">{{ data.ename }}</td>
                    </tr>

                    <tr v-for="(item, key) in data.field" :key="key">
                        <td class="title">{{ item.finame }}</td>
                        <td class="content">{{ item.content ? item.content : '-' }}</td>
                    </tr>

                </table>
            </div>
        </div>
    </div>
</template>

<script>
import listHeader from '@/components/list/listHeader';

export default {
    components: {
        listHeader,
    },
    data() {
        return {
            scenario: 'salaryView',
            visible: false,
            postData: {
                'sdid': '',
            },
            data: {},
            config: {},
        }
    },
    Watch: {
    },
    created() {
        this.setData();
        this.getData();
    },
    methods: {
        setData() {
            for (let i in this.postData) {
                if (this.$route.query[i] === undefined) continue;
                this.postData[i] = this.$route.query[i];
            }
        },
        getData() {
            // 查询数据
            this.http('/manage/salary/info', this.postData, (res) => {
                this.data = res.data;
                this.config = res.config;

            }, null, 2);
        },
    },
}
</script>

<style lang="less" src="../../assets/css/add/add.less"></style>